import styles from "./modal.module.css";
import Link from "next/link";
import Image from "next/image";
import Disappoint from "../../assets/images/home/disappoint.png";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import OtpInput from 'react18-input-otp';
import React, { useState, useEffect } from 'react';
import { otpVerify, otpResend, otpVerifycareer, otpResendcareer, otpVerifyleads, otpResendleads} from "../Service/Otpservice";
import { getCookie, deleteCookie } from 'cookies-next';
import Success from "./Success";

const Otpverification = (props) =>{
  const [otp, setOtp] = useState(null);
  const [otpSumbit, setOtpSumbit] = useState(false);
  const [modalResponse, setmodalResponse] = useState(false);
  const [responseStatus, setresponseStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(59);
  const [otpappear, setOtpappear] = useState(false);
  
  useEffect(() => {
    const interval = setInterval(() => {
      
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
  
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);
  
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const resendOTP = () => {
    setMinutes(1);
    setSeconds(59);
  };

  useEffect(() => {
    resendOTP();
  }, [props.show]);

  const handleChange = (enteredOtp) => {
        setOtp(enteredOtp);
        if(enteredOtp.length==6)
        {
          setOtpSumbit(true);
        } else{
          setOtpSumbit(false);
        }
    }

  const otpSumbitTrigger =(value) => {

    console.log(props.frompage, 'karan');
    const verifyData ={};
    verifyData['id']=getCookie('OtpToken');
    verifyData['code']=value;
    verifyData['formType'] = props.frompage == "allIndiaPrelimsMockTest" ? "AllIndiaPrelimsMockTest" : ''

    // if((props.frompage) == "allIndiaPrelimsMockTest") {
    //   verifyData['formType'] = "AllIndiaPrelimsMockTest";
    // }
    
    setIsLoading(true);

  if((props.frompage) == "CareersForm"){
    otpVerifycareer(verifyData)
    .then((response) =>{
      if (response.status == 400){
        // console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }
  else if((props.frompage) == "UPSCleadform"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  } 

    else if((props.frompage) == "tnpscprelimsMocktest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }


  else if((props.frompage) == "Upschallticketvalidation"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "tnpscmainsiimocktest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "tnpscprelimsnewstd"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");
         const queryParams = new URLSearchParams({
              testTitle:props.payment.testTitle,
                   name:props.payment.name,
               mobileNo:props.payment.phoneNo,
                  email:props.payment.emailaddress,
              modeOfTest:props.payment.modeOfTest,
              testCenter:props.payment.testcenter,
               community:props.payment.community,
                testFees: props.payment.testFees
            }).toString();
            window.location.href = `https://admissionsv1.shankariasacademy.com/tnpscPayment/Paymentscreen?${(queryParams)}`;
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

   else if((props.frompage) == "tnpscmainsmocktest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }




  else if((props.frompage) == "UPSCclassroomandonline"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }
  else if((props.frompage) == "UPSCsiamentoring"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

   else if((props.frompage) == "tnusrbsimocktest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "summercamp"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }


  

  else if((props.frompage) == "Chakraadmission"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "UPSCprelimsmocktest26"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }


  else if((props.frompage) == "Environmentbook"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "DuePayment"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }


    else if((props.frompage) == "setuscholarshiptest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "Upscprelimstestseries2025"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "sadhanaupsc"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "TnpscgroupIandIIpreliminary"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }


  else if((props.frompage) == "admissionconsultation"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "Contactpage"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  else if((props.frompage) == "tnpscprelimsMocktest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }
  else if((props.frompage) == "SIAUPSCMainsMockTest"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }
  else if((props.frompage) == "SIAUPSCMainsTestCenter"){
    otpVerifyleads(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing')
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false); 
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => { 
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }
  else{
    otpVerify(verifyData)
    .then((response) =>{
      if (response.status == 400){
        console.log(response, 'testing');
        setIsLoading(false);
        setOtpappear(true);
        setOtp(null);
      }
      else{
        setTimeout(() => { 
        setresponseStatus("success");  
        setmodalResponse(true);
        setIsLoading(false);
        setOtpappear(false);
        setOtp(null);
        deleteCookie('OtpToken');    
        }, 300);
      }
    })
    .catch(() =>{
      setTimeout(() => {
      setresponseStatus("failure");  
      setmodalResponse(true);
      setIsLoading(false);  
      setOtp(null);
      }, 300);
    })
  }

  }

    const resendOtpCode =() => {
      const verifyData ={};
      verifyData['id']=getCookie('OtpToken');
      verifyData['formType'] = props.frompage == "allIndiaPrelimsMockTest" ? "AllIndiaPrelimsMockTest" : ''

      // if((props.frompage) == "allIndiaPrelimsMockTest") {
      //   verifyData['formType'] = "AllIndiaPrelimsMockTest";
      // } 

      setIsLoading(true);

      if((props.frompage) == "career"){
        otpResendcareer(verifyData)
        .then(() =>{
          setTimeout(() => { 
          setIsLoading(false);  
          }, 300);
        })
        .catch(() =>{
          setTimeout(() => { 
          setIsLoading(false);  
          }, 300);
        })
      }
      else if((props.frompage) == "UPSCleadform"){
        otpResendleads(verifyData)
        .then(() =>{
          setTimeout(() => { 
          setIsLoading(false);  
          }, 300);
        })
        .catch(() =>{
          setTimeout(() => { 
          setIsLoading(false);  
          }, 300);
        })
      }
      else{
        otpResend(verifyData)
        .then(() =>{
          setTimeout(() => { 
          setIsLoading(false);   
          }, 300);
        })
        .catch(() =>{
          setTimeout(() => { 
          setIsLoading(false);  
          }, 300);
        })
      }

    }
    
    return(
        <>

      {isLoading && 
        <div className="APIPreLoader" id="APIPreLoader">
          <div className="loader">Loading...</div>
        </div>
      }

{/* OTP modal */}
    {
       props.title != "failure" ? <Modal
       {...props}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="py-4 py-md-5">
           <p className={`${styles.otpTitleVer} mb-2 text-center`}>
              OTP Verification Required.
           </p>
           <div className={`${styles.acheiverrank} mb-2 text-center`}> {props.title}</div> 

            <div className={`${styles.otpinputfieldarea} mb-2`}>
                <OtpInput value={otp} onChange={handleChange} numInputs={6} isInputNum={true} shouldAutoFocus={true}  className={`${styles.otpinputfield} me-1 mb-2 text-center `} separator={false} />
            </div>
           
             <div className="pt-2 text-center">
                <Button type="button"  disabled={!otpSumbit} className={`${styles.normalbutton} w-75`}  onClick={()=>{otpSumbit && otpSumbitTrigger(otp); otpSumbit &&  props.onHide()}}>Verify & Proceed</Button>
             </div>

             <div  className={`${styles.otpinputfieldarea } my-2 text-center d-flex justify-content-center`}>
                  {seconds > 0 || minutes > 0 ? (
                    <p  className="pe-1">
                      Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds} 
                    </p>
                  ) : (
                    <p className="text-center pe-1">Didn&apos;t receive OTP? </p>
                  )}

                  <div
                    disabled={seconds > 0 || minutes > 0}
                    style={{
                      color: seconds > 0 || minutes > 0 ? "#adb4b9" : "#0D1216",
                      textDecoration:"underline",
                      cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                    }}
                    onClick={()=>{!seconds && resendOtpCode(); !seconds && resendOTP();}}
                  >
                    Resend OTP
                  </div>

                  {/* <div className="">
                    {otperror && <div className="text-danger captachafont">Please enter correct OTP</div>}
                  </div> */}
            </div>
        </Modal.Body>
    </Modal>
    
    :
    
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="py-3 py-md-4 text-center">
        
        { props.exceptionMessage == "" ?

        <>
          <Image src={Disappoint} className="img-fluid" alt="Emoji" title="Emoji" />
          <p className={`${styles.acheiverrank} pt-3 mb-0 text-center`}>
            This page is currently unavailable,
          </p>
          <p className={`${styles.acheiverrank} text-center`}>
            please contact admin for details.
          </p>
          <div className="pt-1 text-center"><Link href="/home"><Button type="button" id={styles.finalmodalbtn} className={`${styles.normalbutton}`}>Back to Home</Button></Link></div>        
        </> 
        
        : 

        <>
        <p className={`${styles.acheiverrank} mb-2 text-center`}>
          {props.exceptionMessage}
        </p>
        <div className="pt-2 text-center"><Button type="button" id={styles.finalmodalbtn} className={`${styles.normalbutton}`} onClick={props.onHide}>Retry</Button></div>
        </>

        }

      </Modal.Body>
    </Modal>
  }

{/* If enter wrong otp modal */}
    <Modal
      show={otpappear}
      size="md"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="py-4 py-md-5">
           <p className={`${styles.otpTitleVer} mb-2 text-center`}>
              OTP Verification Required.
           </p>
           <div className={`${styles.acheiverrank} mb-2 text-center`}> {props.title}</div> 

            <div className={`${styles.otpinputfieldarea} mb-2`}>
                <OtpInput value={otp} onChange={handleChange} numInputs={6} isInputNum={true} shouldAutoFocus={true}  className={`${styles.otpinputfield} me-1 mb-2 text-center `} separator={false} />
            </div>
           
             <div className="pt-2 text-center">
                <Button type="button"  disabled={!otpSumbit} className={`${styles.normalbutton} w-75`}  onClick={()=>{otpSumbit && otpSumbitTrigger(otp); otpSumbit &&  props.onHide()}}>Verify & Proceed</Button>
             </div>

             <div  className={`${styles.otpinputfieldarea } my-2 text-center d-flex justify-content-center`}>
                  {seconds > 0 || minutes > 0 ? (
                    <p  className="pe-1">
                      Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds} 
                    </p>
                  ) : (
                    <p className="text-center pe-1">Didn&apos;t receive OTP? </p>
                  )}

                  <div
                    disabled={seconds > 0 || minutes > 0}
                    style={{
                      color: seconds > 0 || minutes > 0 ? "#adb4b9" : "#0D1216",
                      textDecoration:"underline",
                      cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                    }}
                    onClick={()=>{!seconds && resendOtpCode(); !seconds && resendOTP();}}
                  >
                    Resend OTP
                  </div>
            </div>

                  <div className="">
                    {otpappear && <div className="text-danger text-center captachafont">"Please enter correct OTP"</div>}
                  </div>
        </Modal.Body>
    </Modal>

  {/* Success and failure response */}
    <Success show={modalResponse} title={responseStatus} frompage={props.frompage} onHide={() => setmodalResponse(false)} />

    </>
  )
}
export default Otpverification;

